import { HxNotificationOptions } from '@hubbix/common-components/lib/hx-notifications/models/hx-notification-options';

export const notificationDataOptions: HxNotificationOptions = {
  duration: 2000,
} as const;
